import { faPhone } from '@fortawesome/pro-solid-svg-icons'
import clsx from 'clsx'
import type { CallScheduleEvent } from '~/domains/actions/types'
import {
  historyItemMeta,
  historyItemStatus,
  historyItemStatusCancelled,
  historyItemStatusCompleted,
  historyItemStatusNotCompleted
} from '../ApplicantHistory.css'
import { BaseHistoryCard } from './BaseHistoryCard'
import { HistoryItemContent } from './HistoryItemContent'

const getCallTitle = (event: CallScheduleEvent) => {
  if (event.actionType) {
    return event.actionType
  }
  if (event.isCompleted === null && event.isCancelled === null) {
    return 'Appel programmé'
  }
  return 'Appel'
}

const getCallMeta = (event: CallScheduleEvent) => {
  if (event.isCancelled) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusCancelled)}>
        Annulé
      </span>
    )
  }

  if (event.isCompleted) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusCompleted)}>
        Abouti
      </span>
    )
  }

  if (event.isCompleted === false) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusNotCompleted)}>
        Non abouti
      </span>
    )
  }

  return null
}
export const CallHistoryCard = ({ event }: { event: CallScheduleEvent }) => {
  const meta = getCallMeta(event)

  return (
    <BaseHistoryCard
      event={event}
      icon={faPhone}
      title={
        <>
          {getCallTitle(event)}
          {meta && <div className={historyItemMeta}>{meta}</div>}
        </>
      }
    >
      {event.notes && <HistoryItemContent>{event.notes}</HistoryItemContent>}
    </BaseHistoryCard>
  )
}
